/**
 * Created by agengmaulana on 5/3/17.
 */
import React from 'react'
import styles from './../../assets/css/comment.css'
import Comment_Profile_Image from '../comment_profile_image/comment_profile_image'
import Comment_Username from '../comment_username/comment_username'
import unescapeJs from 'unescape-js'
import PropTypes from 'prop-types'

export default class Comment_Moderation extends React.Component {

    render(){
        const {dataStore,datastoresVerified} = this.props;

        return (
            <div className={styles.cmt_pv_komen}>
                { dataStore.moderasi ? <div className={styles.cmt_title}>Komentar Anda dalam proses moderasi</div> : <div className={styles.cmt_mt15}></div> }
                <div className={styles.cmt_box}>
                    <div className={styles.cmt_list_dk}>
                        <Comment_Profile_Image photo={dataStore.author.photo} mr10="false" nickname={dataStore.author.name}  />
                        <Comment_Username nickname={dataStore.author.name} create_date={dataStore.create_date} mb10="false" verified_user={typeof datastoresVerified[dataStore.author.uniqueid] !== 'undefined'?datastoresVerified[dataStore.author.uniqueid]:false} />
                        <div className={styles.cmt_dk_komen}>
                            {unescape(dataStore.content)}
                        </div>
                    </div>
                </div>
            </div>
        )

    }
}



// WEBPACK FOOTER //
// ./static/src/component/comment_moderation/comment_moderation.js